module.exports = __webpack_public_path__ + "img/1530051879.5e457746.jpg";